(function ($) {
    $.widget("ui.Staff",
        {
            options:
            {
                LoadingTitle: 'Loading Contact Information...',
                SuccessTitle: 'Contact Information',
                ErrorTitle: 'Error Loading Contact Information',
                LoadingContent: 'Loading contact information.',
                ErrorContent: 'Error loading contact information.',
                ResultSelector: '.fbcms_card',
                ResultListSelector: '.fbcms_cards',
                MasonrySelector: '.fbcms_contentbody.masonry',
                SkiplinksContainerSelector: '.fbcms_card_skiplinks',
                SkiplinkSelector: '.skiplink'
            },

            _destroy: function () {
            },

            _init: function () {
            },

            _create: function () {
                var self = this;
                var jElement = $(self.element);

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.ResultListSelector)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.ResultSelector)) {
                    FBUtilities.LogMessage('StaffCards - required settings null or empty.');
                    return;
                }

                jElement.on(
                    'click',
                    '.contact_button',
                    function (aEvent) {
                        aEvent.preventDefault();
                        var selectedElement = $(this);
                        self._doContactButtonAction(selectedElement, selectedElement);
                        return false;
                    }
                );

                self._InitMasonry();

                self.SetupCardButtons();
            },

            _doContactButtonAction: function (aSelectedElement, aTopElement) {
                var self = this;
                var jElement = $(self.element);

                var lElement = aSelectedElement;
                if (lElement.length == 0) {
                    return;
                }

                if (!lElement.is('a')
                    && lElement.parent().is('a')) {
                    lElement = $(lElement.parent());
                }

                var lUrl = lElement.data('url');
                if (FBUtilities.IsParameterUndefinedOrEmpty(lUrl)) {
                    return;
                }

                self._showContactInfo(lUrl, aSelectedElement);
            },

            _showContactInfo: function (aUrl, aTopElement) {
                var self = this;
                var jElement = $(self.element);

                new FBAjaxDialog().Start({
                    AjaxUrl: aUrl
                    , ExtraDialogClasses: 'fbd_contactform'
                    , LoadingDialogTitle: self.options.LoadingTitle
                    , SuccessDialogTitle: self.options.SuccessTitle
                    , ErrorDialogTitle: self.options.ErrorTitle
                    , LoadingContent: self.options.LoadingContent
                    , ErrorContent: self.options.ErrorContent
                    , SelectionElement: aTopElement
                }
                );
            },

            _InitMasonry: function () {
                var self = this;
                var jElement = $(self.element);

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.MasonrySelector)) {
                    return;
                }

                var lContainer = jElement.find(self.options.MasonrySelector);

                if (lContainer.length === 1) {
                    var lMasonry = lContainer.imagesLoaded(function () {
                        // init Masonry after all images have loaded
                        lMasonry.masonry(
                            {
                                // options
                                itemSelector: self.options.ResultSelector,
                                columnWidth: self.options.ResultSelector
                            });
                    });
                }
            },

            SetupCardButtons: function () {
                var self = this;
                var jElement = $(self.element);

                var lContainer = jElement.find(self.options.ResultListSelector);
                var lCards = lContainer.find(self.options.ResultSelector);

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.SkiplinksContainerSelector) === false
                    && FBUtilities.IsStringEmptyOrWhitespace(self.options.SkiplinkSelector) === false) {
                    $.each(
                        lCards,
                        function (aIndex, aValue) {
                            var lCard = $(aValue);
                            lCard.find(self.options.SkiplinksContainerSelector).DropFocusManager(
                                {
                                    TitleOpenerSelector: self.options.SkiplinkSelector
                                    , DropLinksSelector: self.options.SkiplinkSelector
                                }
                            );
                        }
                    );
                }
            }
        });

})(jQuery);

(function ($) {
    $.widget("ui.StaffSearch",
        {
            options:
            {
                PageContentId: null,
                ResultsContainerSelector: null,
                FormDivSelector: ".fbcms_staff_search_form",
                LoadingTitle: 'Loading Contact Information...',
                SuccessTitle: 'Contact Information',
                ErrorTitle: 'Error Loading Contact Information',
                LoadingContent: 'Loading contact information.',
                ErrorContent: 'Error loading contact information.',
            },

            _destroy: function () {
            },

            _init: function () {
            },

            _create: function () {
                var self = this;
                var jElement = $(self.element);
                var jResultsContainer = jElement.find("#" + self.options.ResultsContainerId);

                jElement.on(
                    'click',
                    '.contact_button',
                    function (event) {
                        event.preventDefault();
                        let selectedElement = $(this);
                        self._doContactButtonAction(selectedElement, selectedElement);
                        return false;
                    }
                );

                jElement.find('.search_button').click(function (aEvent) {
                    aEvent.preventDefault();
                    self.SubmitForm();
                    return false;
                });

                jElement.find('.reset_button').click(function (aEvent) {
                    aEvent.preventDefault();
                    self.ResetForm();
                    return false;
                });

                jElement.find('#fbcms_staff_search_district, #fbcms_staff_search_building, #fbcms_staff_search_department, #fbcms_staff_search_position').change(function (aEvent) {
                    aEvent.preventDefault();
                    self.SubmitForm();
                    return false;
                });

                jElement.find('#SearchString').on(
                    'keypress',
                    function (aEvent) {
                        if (aEvent.key === "Enter") {
                            aEvent.preventDefault();
                            self.SubmitForm();
                            return false;
                        }
                        // nevermind, carry on...
                        return true;
                    }
                );

                jElement.AjaxContentPagination(
                    {
                        NavigationUrl: `/Core/Staff/SearchAjax/${self.options.PageContentId}/`,
                        LoadingTitle: "Contact Information",
                        NormalContainer: jResultsContainer,
                        // TODO: CHECK IF WE REALLY NEED TO USE A SUBCONTAINER HERE??
                        MoreContainer: jResultsContainer,
                        InitialPagerData: self.options.InitialPagerData,
                        RequestDataFunc: function (isNewSearch, isReset) {
                            return self.GetSearchData(isNewSearch, isReset);
                        },
                        LiveRegionId: self.options.ResultsContainerId
                    });

                $(this.element).AjaxContentPagination('ChangePage', 1);
            },

            _doContactButtonAction: function (aSelectedElement, aTopElement) {
                var lElement = aSelectedElement;
                if (lElement.length == 0) {
                    return;
                }

                if (!lElement.is('a') && lElement.parent().is('a')) {
                    lElement = $(lElement.parent());
                }

                var lUrl = lElement.data('url');
                if (FBUtilities.IsParameterUndefinedOrEmpty(lUrl)) {
                    return;
                }

                this._showContactInfo(lUrl, aSelectedElement);
            },

            _showContactInfo: function (aUrl, aTopElement) {
                var self = this;
                var jElement = $(self.element);

                new FBAjaxDialog().Start({
                    AjaxUrl: aUrl
                    , ExtraDialogClasses: 'fbd_contactform'
                    , LoadingDialogTitle: self.options.LoadingTitle
                    , SuccessDialogTitle: self.options.SuccessTitle
                    , ErrorDialogTitle: self.options.ErrorTitle
                    , LoadingContent: self.options.LoadingContent
                    , ErrorContent: self.options.ErrorContent
                    , SelectionElement: aTopElement
                }
                );
            },

            GetSearchData: function (aIsNewSearch, aIsReset) {
                var self = this;
                var jElement = $(self.element);
                var jFormDiv = jElement.find(self.options.FormDivSelector);

                return {
                    "PageContentId": self.options.PageContentId,
                    "SearchString": encodeURIComponent(jFormDiv.find('#SearchString').val()),
                    "DistrictId": jFormDiv.find('#fbcms_staff_search_district').val(),
                    "BuildingId": jFormDiv.find('#fbcms_staff_search_building').val(),
                    "DepartmentId": jFormDiv.find('#fbcms_staff_search_department').val(),
                    "PositionId": jFormDiv.find('#fbcms_staff_search_position').val(),
                    "IsNewSearch": aIsNewSearch === undefined ? false : aIsNewSearch,
                    "IsReset": aIsReset === undefined ? false : aIsReset
                };
            },

            SubmitForm: function () {
                $(this.element).AjaxContentPagination('SubmitForm');
            },

            ResetForm: function () {
                let jElement = $(this.element);
                let jFormDiv = jElement.find(this.options.FormDivSelector);
                jFormDiv.find('#SearchString').val('');
                jFormDiv.find('#fbcms_staff_search_district').val('');
                jFormDiv.find('#fbcms_staff_search_building').val('');
                jFormDiv.find('#fbcms_staff_search_department').val('');
                jFormDiv.find('#fbcms_staff_search_position').val('');
                jElement.AjaxContentPagination('ResetForm');
            }
        });
})(jQuery);